// Configuration du wizard IAM Maturity Assessment
// Couche 1 : Questions business pour leads Google Ads

export const wizardConfig = {
  steps: [
    {
      id: 'perimetre',
      title: 'Votre périmètre',
      icon: '🏢',
      subtitle: 'Parlons de votre contexte'
    },
    {
      id: 'gestion',
      title: 'Votre gestion actuelle',
      icon: '⚙️',
      subtitle: 'Comment gérez-vous l\'authentification aujourd\'hui ?'
    },
    {
      id: 'risques',
      title: 'Risques & Sécurité',
      icon: '🔒',
      subtitle: 'Évaluons votre niveau de protection'
    },
    {
      id: 'ambitions',
      title: 'Vos ambitions',
      icon: '🚀',
      subtitle: 'Où voulez-vous aller ?'
    }
  ],

  questions: {
    perimetre: [
      {
        id: 'users',
        label: 'Combien d\'utilisateurs vos applications gèrent-elles ?',
        type: 'radio',
        options: [
          { value: 'lt1k',    label: 'Moins de 1 000',          score: { gouvernance: 5,  securite: 5,  efficacite: 20, strategie: 5  } },
          { value: '1k10k',   label: 'De 1 000 à 10 000',       score: { gouvernance: 10, securite: 8,  efficacite: 15, strategie: 8  } },
          { value: '10k100k', label: 'De 10 000 à 100 000',     score: { gouvernance: 15, securite: 12, efficacite: 10, strategie: 12 } },
          { value: 'gt100k',  label: 'Plus de 100 000',         score: { gouvernance: 20, securite: 15, efficacite: 5,  strategie: 15 } }
        ]
      },
      {
        id: 'apps',
        label: 'Sur combien d\'applications ?',
        type: 'radio',
        options: [
          { value: '1',    label: '1 application',      score: { gouvernance: 5,  securite: 5,  efficacite: 20, strategie: 5  } },
          { value: '2-5',  label: '2 à 5 applications', score: { gouvernance: 10, securite: 10, efficacite: 15, strategie: 10 } },
          { value: '6-20', label: '6 à 20 applications',score: { gouvernance: 15, securite: 15, efficacite: 8,  strategie: 15 } },
          { value: 'gt20', label: 'Plus de 20',          score: { gouvernance: 20, securite: 18, efficacite: 5,  strategie: 20 } }
        ]
      }
    ],
    gestion: [
      {
        id: 'approche',
        label: 'Comment gérez-vous l\'authentification aujourd\'hui ?',
        type: 'radio',
        options: [
          { value: 'custom',    label: 'Code maison développé en interne',              score: { gouvernance: 5,  securite: 5,  efficacite: 5,  strategie: 10 } },
          { value: 'libs',      label: 'Bibliothèques open source (Passport, Keycloak…)', score: { gouvernance: 12, securite: 12, efficacite: 12, strategie: 12 } },
          { value: 'iam',       label: 'Solution IAM dédiée (hors Auth0)',               score: { gouvernance: 18, securite: 18, efficacite: 18, strategie: 15 } },
          { value: 'aucune',    label: 'Pas de gestion structurée',                      score: { gouvernance: 0,  securite: 0,  efficacite: 0,  strategie: 5  } }
        ]
      },
      {
        id: 'heures',
        label: 'Combien d\'heures/mois vos équipes consacrent-elles à l\'authentification ?',
        type: 'radio',
        options: [
          { value: 'lt5',   label: 'Moins de 5h',   score: { gouvernance: 20, securite: 5,  efficacite: 20, strategie: 10 } },
          { value: '5-20',  label: '5 à 20h',       score: { gouvernance: 15, securite: 10, efficacite: 15, strategie: 12 } },
          { value: '20-50', label: '20 à 50h',      score: { gouvernance: 8,  securite: 8,  efficacite: 8,  strategie: 15 } },
          { value: 'gt50',  label: 'Plus de 50h',   score: { gouvernance: 3,  securite: 5,  efficacite: 3,  strategie: 20 } }
        ]
      },
      {
        id: 'equipe',
        label: 'Avez-vous un référent ou une équipe IAM dédiée ?',
        type: 'radio',
        options: [
          { value: 'oui',   label: 'Oui, équipe dédiée en interne',  score: { gouvernance: 20, securite: 20, efficacite: 20, strategie: 15 } },
          { value: 'dev',   label: 'Non, géré par les développeurs', score: { gouvernance: 8,  securite: 8,  efficacite: 8,  strategie: 12 } },
          { value: 'ext',   label: 'Non, externalisé',               score: { gouvernance: 12, securite: 12, efficacite: 12, strategie: 10 } },
          { value: 'non',   label: 'Aucun référent identifié',       score: { gouvernance: 3,  securite: 3,  efficacite: 3,  strategie: 8  } }
        ]
      }
    ],
    risques: [
      {
        id: 'incidents',
        label: 'Des incidents d\'authentification ont-ils déjà impacté vos utilisateurs ?',
        type: 'radio',
        options: [
          { value: 'jamais',   label: 'Jamais',                   score: { gouvernance: 20, securite: 25, efficacite: 20, strategie: 5  } },
          { value: '1-2',      label: '1 à 2 fois',               score: { gouvernance: 12, securite: 15, efficacite: 12, strategie: 10 } },
          { value: 'regulier', label: 'Régulièrement',            score: { gouvernance: 3,  securite: 5,  efficacite: 3,  strategie: 18 } },
          { value: 'nsp',      label: 'Je ne sais pas',           score: { gouvernance: 5,  securite: 8,  efficacite: 5,  strategie: 15 } }
        ]
      },
      {
        id: 'passwords',
        label: 'Comment vos mots de passe utilisateurs sont-ils protégés ?',
        type: 'radio',
        options: [
          { value: 'bcrypt',   label: 'Hashage sécurisé (bcrypt, Argon2, PBKDF2)', score: { gouvernance: 20, securite: 25, efficacite: 20, strategie: 5  } },
          { value: 'md5',      label: 'Hashage basique (MD5, SHA1)',                score: { gouvernance: 5,  securite: 8,  efficacite: 8,  strategie: 15 } },
          { value: 'clair',    label: 'En clair ou chiffrement réversible',         score: { gouvernance: 0,  securite: 0,  efficacite: 5,  strategie: 20 } },
          { value: 'nsp',      label: 'Je ne sais pas',                             score: { gouvernance: 3,  securite: 5,  efficacite: 5,  strategie: 18 } }
        ]
      },
      {
        id: 'conformite',
        label: 'Avez-vous des contraintes réglementaires ? (plusieurs choix possibles)',
        type: 'checkbox',
        options: [
          { value: 'rgpd',    label: 'RGPD',        score: { gouvernance: 5,  securite: 5,  efficacite: 3,  strategie: 8  } },
          { value: 'iso',     label: 'ISO 27001',   score: { gouvernance: 8,  securite: 8,  efficacite: 5,  strategie: 10 } },
          { value: 'soc2',    label: 'SOC 2',       score: { gouvernance: 8,  securite: 8,  efficacite: 5,  strategie: 10 } },
          { value: 'pci',     label: 'PCI-DSS',     score: { gouvernance: 10, securite: 10, efficacite: 5,  strategie: 12 } },
          { value: 'aucune',  label: 'Aucune pour l\'instant', score: { gouvernance: 0, securite: 0, efficacite: 0, strategie: 0 } }
        ]
      }
    ],
    ambitions: [
      {
        id: 'objectifs',
        label: 'Quels sont vos objectifs prioritaires ? (plusieurs choix possibles)',
        type: 'checkbox',
        options: [
          { value: 'secu',    label: 'Renforcer la sécurité et réduire les incidents',   score: { gouvernance: 5, securite: 8,  efficacite: 3,  strategie: 5  } },
          { value: 'sso',     label: 'SSO — Une seule connexion pour toutes mes apps',   score: { gouvernance: 8, securite: 5,  efficacite: 8,  strategie: 8  } },
          { value: 'mfa',     label: 'MFA — Authentification multi-facteurs',            score: { gouvernance: 5, securite: 8,  efficacite: 3,  strategie: 5  } },
          { value: 'couts',   label: 'Réduire les coûts et le temps dev',               score: { gouvernance: 5, securite: 3,  efficacite: 8,  strategie: 5  } },
          { value: 'conform', label: 'Répondre aux exigences de conformité',            score: { gouvernance: 8, securite: 8,  efficacite: 3,  strategie: 8  } },
          { value: 'scale',   label: 'Scalabilité — Préparer la croissance',            score: { gouvernance: 5, securite: 3,  efficacite: 5,  strategie: 8  } },
          { value: 'ux',      label: 'Améliorer l\'expérience de connexion utilisateur', score: { gouvernance: 3, securite: 3,  efficacite: 5,  strategie: 5  } }
        ]
      },
      {
        id: 'horizon',
        label: 'Quel est votre horizon de migration ?',
        type: 'radio',
        options: [
          { value: 'lt3',   label: 'Moins de 3 mois — Urgence identifiée',  score: { gouvernance: 15, securite: 10, efficacite: 10, strategie: 25 } },
          { value: '3-6',   label: '3 à 6 mois — Projet en cours',         score: { gouvernance: 20, securite: 15, efficacite: 15, strategie: 20 } },
          { value: '6-12',  label: '6 à 12 mois — En planification',       score: { gouvernance: 15, securite: 10, efficacite: 12, strategie: 15 } },
          { value: 'gt12',  label: 'Plus de 12 mois',                      score: { gouvernance: 8,  securite: 5,  efficacite: 8,  strategie: 8  } },
          { value: 'nsp',   label: 'Pas encore défini',                    score: { gouvernance: 5,  securite: 5,  efficacite: 5,  strategie: 5  } }
        ]
      },
      {
        id: 'connaissance',
        label: 'Avez-vous déjà évalué Auth0 ?',
        type: 'radio',
        options: [
          { value: 'non',   label: 'Non, jamais',                     score: { gouvernance: 5,  securite: 5,  efficacite: 5,  strategie: 5  } },
          { value: 'exp',   label: 'Oui, en phase d\'exploration',    score: { gouvernance: 12, securite: 10, efficacite: 10, strategie: 15 } },
          { value: 'poc',   label: 'Oui, POC en cours',               score: { gouvernance: 18, securite: 15, efficacite: 15, strategie: 20 } },
          { value: 'oui',   label: 'Oui, décision prise',             score: { gouvernance: 22, securite: 20, efficacite: 20, strategie: 25 } }
        ]
      }
    ]
  },

  analysisSteps: [
    'Analyse de votre gouvernance IAM...',
    'Évaluation de votre posture sécurité...',
    'Calcul de votre efficacité opérationnelle...',
    'Mesure de votre maturité stratégique...',
    'Génération de votre score de maturité IAM...',
    'Préparation de vos recommandations personnalisées...'
  ],

  maturityLevels: [
    {
      min: 0,  max: 25,
      level: 'Niveau 1 — Débutant',
      shortLevel: 'Débutant',
      color: 'text-red-400',
      bgColor: 'bg-red-400',
      borderColor: 'border-red-400/30',
      description: 'Gestion artisanale, risques critiques',
      urgency: 'CRITIQUE',
      urgencyColor: 'text-red-400',
      message: 'Votre infrastructure IAM présente des risques critiques. Une migration vers Auth0 est urgente pour protéger vos utilisateurs et votre activité.',
      recommendation: 'Migration prioritaire sous 3 mois'
    },
    {
      min: 26, max: 50,
      level: 'Niveau 2 — En développement',
      shortLevel: 'En développement',
      color: 'text-orange-400',
      bgColor: 'bg-orange-400',
      borderColor: 'border-orange-400/30',
      description: 'Pratiques émergentes, optimisations critiques',
      urgency: 'ÉLEVÉ',
      urgencyColor: 'text-orange-400',
      message: 'Vous avez posé des bases mais des lacunes importantes subsistent. Auth0 vous permettra de combler ces gaps rapidement.',
      recommendation: 'Migration recommandée sous 6 mois'
    },
    {
      min: 51, max: 75,
      level: 'Niveau 3 — Avancé',
      shortLevel: 'Avancé',
      color: 'text-blue-400',
      bgColor: 'bg-blue-400',
      borderColor: 'border-blue-400/30',
      description: 'Bonnes pratiques en place, optimisations possibles',
      urgency: 'MODÉRÉ',
      urgencyColor: 'text-blue-400',
      message: 'Bonne base ! Auth0 vous apportera scalabilité, conformité avancée et réduction significative des coûts opérationnels.',
      recommendation: 'Migration conseillée pour optimisation'
    },
    {
      min: 76, max: 100,
      level: 'Niveau 4 — Expert',
      shortLevel: 'Expert',
      color: 'text-green-400',
      bgColor: 'bg-green-400',
      borderColor: 'border-green-400/30',
      description: 'Maturité IAM forte, leadership reconnu',
      urgency: 'FAIBLE',
      urgencyColor: 'text-green-400',
      message: 'Excellente maturité IAM ! Auth0 vous permettra d\'aller encore plus loin avec des fonctionnalités enterprise avancées.',
      recommendation: 'Migration pour croissance et optimisation'
    }
  ]
};

// Score calculation: returns { total, gouvernance, securite, efficacite, strategie }
export function calculateIAMScore(answers) {
  const dims = { gouvernance: 0, securite: 0, efficacite: 0, strategie: 0 };
  const maxDims = { gouvernance: 0, securite: 0, efficacite: 0, strategie: 0 };

  Object.entries(wizardConfig.questions).forEach(([stepId, questions]) => {
    const stepAnswers = answers[stepId] || {};
    questions.forEach(q => {
      if (q.type === 'radio') {
        const selected = stepAnswers[q.id];
        // find max possible for this question
        const maxOpt = q.options.reduce((best, opt) => {
          Object.keys(opt.score).forEach(d => {
            if ((opt.score[d] || 0) > (best[d] || 0)) best[d] = opt.score[d];
          });
          return best;
        }, {});
        Object.keys(dims).forEach(d => { maxDims[d] += maxOpt[d] || 0; });

        if (selected) {
          const opt = q.options.find(o => o.value === selected);
          if (opt) Object.keys(dims).forEach(d => { dims[d] += opt.score[d] || 0; });
        }
      } else if (q.type === 'checkbox') {
        const selected = stepAnswers[q.id] || [];
        // max = sum of top 3 options per dimension (reasonable max for checkboxes)
        const sorted = q.options.slice().sort((a, b) => {
          const sumA = Object.values(a.score).reduce((s, v) => s + v, 0);
          const sumB = Object.values(b.score).reduce((s, v) => s + v, 0);
          return sumB - sumA;
        });
        const top = sorted.slice(0, 3);
        top.forEach(opt => Object.keys(dims).forEach(d => { maxDims[d] += opt.score[d] || 0; }));

        selected.forEach(val => {
          const opt = q.options.find(o => o.value === val);
          if (opt) Object.keys(dims).forEach(d => { dims[d] += opt.score[d] || 0; });
        });
      }
    });
  });

  // Normalize each dimension to 0-25 and sum to 0-100
  const normalized = {};
  Object.keys(dims).forEach(d => {
    normalized[d] = maxDims[d] > 0 ? Math.round((dims[d] / maxDims[d]) * 25) : 0;
  });
  const total = Math.min(
    normalized.gouvernance + normalized.securite + normalized.efficacite + normalized.strategie,
    100
  );
  return { total, ...normalized };
}

export function getMaturityLevel(score) {
  return wizardConfig.maturityLevels.find(l => score >= l.min && score <= l.max)
    || wizardConfig.maturityLevels[0];
}
